import { get, postj } from '@/utils/request';

export const afficheList = (param) => get('affiche/list',param); // 公告列表
export const afficheDetail = (param) => get('affiche/detail',param); // 公告详情